import * as ActionTypes from '../constants/actionTypes';

export const initialState = {
    request: false,
    error: '',
    data: {},
};

export default function models(state = initialState, action) {

    switch (action.type) {
        case ActionTypes.TESTDRIVE_REQUEST:
            return {
                ...state,
                request: true,
                error: '',
            };

        case ActionTypes.TESTDRIVE_SUCCESS:
            return {
                ...state,
                request: false,
                error: '',
                data: action.payload
            };

        case ActionTypes.TESTDRIVE_ERROR:
            return {
                ...state,
                request: false,
                error: action.payload
            };

        default :
            return state;
    }

}